{
  "certificates": {
    "kpiConnector": "Connettore KPI",
    "trustore": "Truststore",
    "s4Device": "Apparati S4",
    "s4ToolsApp": "Applicazioni S4-Tools",
    "s4ManagerApp": "Applicazioni S4-Manager",
    "s4ViewApp": "Applicazioni S4-View",
    "sg4000": "Applicazioni SG4000",
    "requiredFields": "I campi preceduti da un * sono obbligatori.",
    "delayInfo": "Il termine per il rinnovo automatico fa riferimento al termine antecedente alla data di scadenza del certificato a partire da cui viene attivato l’avvio automatico della procedura di rinnovo del certificato.",
    "delayPlaceholder": "Termine per il rinnovo automatico",
    "delayPlaceholderCustom": "Termine per il rinnovo automatico (in giorni)",
    "pollingPlaceholder": "Frequenza di polling (minuti)",
    "pollingInfoDevice": "La frequenza di polling corrisponde al termine tra 2 scambi tra LX CONNECT e l’apparato.",
    "pollingInfoApplication": "La frequenza di polling corrisponde al termine tra 2 scambi tra LX CONNECT e l’applicazione.",
    "autoActivationLabel": "Attivazione automatica",
    "autoActivationAction": "Attivare",
    "autoActivationInfoApplication": "L’attivazione automatica permette di attivare l’applicazione nel momento dell’approvvigionamento.",
    "autoActivationInfoDevice": "L’attivazione automatica permette di attivare l’apparato nel momento dell’approvvigionamento.",
    "title": "Certificati"
  },
  "firmware": {
    "title": "Firmware",
    "firmwareManagement": "Gestione dei firmware"
  },
  "users": {
    "title": "Utenti",
    "activeDirectory": "Active Directory"
  },
  "application": {
    "title": "Configurazione dell’applicazione",
    "smtpServor": "Server SMTP",
    "feelAndIdentity": "Aspetto e identità"
  },
  "applicationMgt": {
    "title": "Applicazioni",
    "applicationManagement": "Gestione delle applicazioni"
  },
  "usersPreference": {
    "title": "Preferenze dell’utente",
    "userParams": "Parametri utente"
  },
  "technicalVersion": {
    "label": "Versione tecnica:",
    "unknown": "sconosciuta"
  },
  "version": {
    "label": "Versione:",
    "unknown": "sconosciuta"
  },
  "platformMgt": {
    "title": "Piattaforma",
    "about": "Informazioni"
  },
  "deviceConfiguration": "Configurazione degli apparati"
}
